import { Icon } from "@innovationnorway/lighthouse-components";
import React, { HTMLAttributes } from "react";
import "./infoBanner.scss";

interface InfoBannerProps extends HTMLAttributes<HTMLDivElement> {
  variant: "info" | "warning" | "error" | "success";
}

export const InfoBanner = ({ variant, children, className, ...props }: InfoBannerProps) => {
  const icons = {
    info: "circle-info",
    warning: "triangle-exclamation",
    error: "circle-xmark",
    success: "check-circle"
  };

  const getIconForVariant = (variant: string) => {
    switch (variant) {
      case "info":
        return icons.info;
      case "warning":
        return icons.warning;
      case "error":
        return icons.error;
      case "success":
        return icons.success;
      default:
        return icons.info;
    }
  };

  return (
    <div className={`info-banner info-banner_${variant} ${className}`} {...props}>
      <Icon iconName={getIconForVariant(variant)} prefix="fasr" />
      {children}
    </div>
  );
};
